import styled from 'styled-components'
import { COLORS } from 'utils'

interface IContainer {
  margin?: string
}
export const Container = styled.div<IContainer>`
  width: 100%;
  max-width: 335px;
  min-height: 343px;
  height: auto;
  background: ${COLORS.white};
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.25);
  margin: ${({ margin }) => margin || 'auto'};
`

export const TitleContainer = styled.div`
  background: ${COLORS.tableColor};
  padding: 9px 6px;
  text-align: center;
  text-transform: uppercase;
`
export const Content = styled.div`
  width: auto;
  min-height: 343px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2%;
`
